<template>
  <div class="model-list">
    <header class="header">
      <h1>Web Wide World</h1>
      <p>By Nobdy, For Everyone：平凡人共创普惠世界</p>
    </header>
    <div class="baidu-search-box">
      <input
        v-model="modelUrl"
        type="text"
        class="baidu-input"
        placeholder="请填入场景 URL"
        @keydown.enter="goToViewer"
      />
      <button class="baidu-btn" @click="goToViewer">
        Go
        <svg class="btn-icon" width="18" height="18" viewBox="0 0 20 20">
          <polyline
            points="7 5 13 10 7 15"
            fill="none"
            stroke="#fff"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
    <div class="models-grid">
      <div
        v-if="modelList.length > 0"
        v-for="model in modelList"
        :key="model.id"
        class="model-card"
        @click="goToModel(model)"
      >
        <div class="model-preview">
          <div class="model-icon">🎯</div>
          <h3>{{ model.name }}</h3>
        </div>
        <div class="model-info">
          <button class="view-button">查看详情</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
// import { useRouter } from 'vue-router';
// import { ModelList } from '../configs'
// import SuccessDialog from '../components/successDialog.vue'
// const router = useRouter();
const modelList = ref([]);
const modelUrl = ref('');
const show = ref(false);
// const contentRef = ref(null);

onMounted(async () => {
  //   const el = contentRef.value;
  //   console.log(1, el);
  //   el.addEventListener('touchstart', handleTouchStart, { passive: false });
  //   el.addEventListener('touchmove', handleTouchMove, { passive: false });
  const requestFile = await fetch(
    'https://mogs-1300354879.cos.ap-shanghai.myqcloud.com/mogs/timi-activity/gs-viewer/config/scene.json',
    {
      mode: 'cors',
      credentials: 'omit',
      cache: 'reload',
    },
  );
  console.log(1111, requestFile);
  if (requestFile.status !== 200) {
    return new Error(`load  error ${requestFile.statusText},${requestFile.body}`);
  }
  const content = await requestFile.json();
  modelList.value = content.sceneConfig;
  console.log(`success file url content:`, content);
  // document.addEventListener('touchmove', touchHandler, { passive: false });
});

const goToModel = (itemInfo) => {
  console.log('goToModel===', itemInfo);
  let url = `/viewer?sceneUrl=${itemInfo.modelUrl}`;
  console.log('goToModel===', location.href);
  // const index = location.href.indexOf('home.html');
  // console.log('index===', index, location.href.slice(0, index));
  // const fullUrl = `${location.href.slice(0, index)}index.html#${url}`;
  // console.log('baseUrl===', fullUrl);
  // window.location.href = fullUrl;
  window.location.hash = `#/viewer?sceneUrl=${itemInfo.modelUrl}`;
};
const goToViewer = () => {
  console.log('goToViewer===');
  if (modelUrl.value) {
    // const index = location.href.indexOf('home.html');
    console.log('goToModel===', location.href);
    // const fullUrl = `${location.href.slice(0, index)}index.html#/viewer?sceneUrl=${modelUrl.value}`;
    // window.location.href = fullUrl;
    window.location.hash = `#/viewer?sceneUrl=${modelUrl.value}`;

  }
};
// 定义事件处理函数（避免匿名函数，方便后续解绑）
// const touchHandler = (e) => {
//   // 仅阻止页面顶部下拉的伸缩行为
//   if (document.documentElement.scrollTop < 0) {
//     e.preventDefault();
//   }
// };
const handleTouchStart = (e) => {
  const el = contentRef.value;
  console.log('handleTouchStart===', el);
  const scrollTop = el.scrollTop;
  const scrollHeight = el.scrollHeight;
  const offsetHeight = el.offsetHeight;

  // 判断是否滚动到最顶部或底部
  el._isAtTop = scrollTop === 0;
  el._isAtBottom = scrollTop + offsetHeight >= scrollHeight;
  el._startY = e.touches[0].clientY;
};

const handleTouchMove = (e) => {
  const el = contentRef.value;
  console.log('handleTouchMove===', el);
  const currentY = e.touches[0].clientY;
  const diffY = currentY - el._startY;

  // 到顶部且继续往下拉，或到底部继续往上拉，阻止默认回弹
  if ((el._isAtTop && diffY > 0) || (el._isAtBottom && diffY < 0)) {
    // e.preventDefault(); // 阻止回弹
  }
};
</script>
<style scoped>
body {
  overflow: hidden;
  /* height: 100vh; */
  overflow: scroll;
  overscroll-behavior-y: none;
}
.scroll-container {
  overflow-y: auto;
  height: 100%;
}
#app {
 overscroll-behavior-y: none;
  width: 100%;
  height: 100vh;
  /* background-color: red; */
}
.model-list {
  /* position: relative;
  z-index: 1000; */
  /* height: 100%; */
  overflow-y: scroll;
  /* overscroll-behavior-y: none; */
  height: 100vh;
  /* min-height: 100vh; */
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
}

.header {
  text-align: center;
  color: white;
  margin-bottom: 3rem;
}

.header h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  font-weight: 300;
}

.header p {
  font-size: 1.1rem;
  opacity: 0.9;
}
.label-c {
  font-size: 1.1rem;
  opacity: 0.9;
  color: white;
  margin-right: 1rem;
}
.model-url {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
}
.input-url-c {
  margin-left: 1rem;
}
.baidu-search-box {
  display: flex;
  justify-content: center;
  /* width: 100%; */
  align-items: center;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(75, 144, 214, 0.08);
  border: 1.5px solid #e0e3ea;
  /* width: 340px; */
  background: #fff;
  /* max-width: 1200px; */
  max-width: 800px;
  margin: 0 auto 1.5rem;
}

.baidu-input {
  flex: 1;
  padding: 0 18px;
  height: 46px;
  border: none;
  outline: none;
  font-size: 1.07em;
  background: transparent;
  color: #222f3a;
  transition: background 0.17s;
  border-color: #2171e6;
}
.baidu-input::placeholder {
  color: #b4bcc9;
  letter-spacing: 0.01em;
}
.baidu-input:focus {
  background: #f5faff;
}

.baidu-btn {
  display: flex;
  align-items: center;
  gap: 0.25em;
  height: 46px;
  padding: 0 21px 0 16px;
  background: #3385ff; /* 百度蓝 */
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 1.08em;
  font-weight: 600;
  border-radius: 0 14px 14px 0;
  transition:
    background 0.18s,
    box-shadow 0.19s;
  box-shadow: 0 2px 8px rgba(50, 132, 255, 0.12);
  user-select: none;
}
.baidu-btn .btn-icon {
  margin-left: 3px;
}

.baidu-btn:hover,
.baidu-btn:focus {
  background: #2171e6; /* 悬停更深蓝 */
  box-shadow: 0 6px 18px rgba(52, 124, 255, 0.13);
}

.baidu-btn:active {
  background: #1556b6;
  box-shadow: 0 2px 6px rgba(52, 124, 255, 0.1);
}
.models-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  /* overflow: scroll;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center; */
  max-width: 800px;
  margin: 0 auto;
  padding-bottom: 10rem;
}

.model-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
  opacity: 0.75;
  /* min-width: 200px; */
  /* max-width: 500px; */
}

.model-card:hover {
  /* transform: translateY(-10px); */
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  opacity: 1;
}

.model-preview {
  padding: 2rem;
  text-align: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.model-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.model-preview h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
  font-weight: 500;
}

.model-info {
  padding: 1.5rem;
}

.model-info p {
  margin: 0 0 1.5rem 0;
  color: #666;
  line-height: 1.6;
}

.view-button {
  width: 100%;
  padding: 0.75rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.view-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

</style>
